"use client";

import React from "react";
import { ArrowRight, ChartBar, CircleCheck, Handshake, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Link } from "@/components/common/Link";
const servicesData = [{
  id: "ma",
  tabLabel: "Rede de contatos",
  title: "Ecossistema de Elite",
  description: "Conecte-se com uma rede exclusiva de líderes seniores e tomadores de decisão. Nossa comunidade promove trocas estratégicas que transcendem o networking convencional.",
  bullets: "Acesso a 500+ líderes seniores|Presença em 15+ indústrias globais|Eventos de networking de alto nível|Fóruns de discussão executiva privada",
  link: "/HomePage",
  icon: Handshake
}, {
  id: "fundraising",
  tabLabel: "Mentoria",
  title: "Orientação Estratégica",
  description: "Mentoria personalizada focada em longevidade profissional e transição de carreira para executivos que buscam novos horizontes e impacto sustentável.",
  bullets: "Conselheiros com vasta experiência|Planejamento de sucessão e transição|Desenvolvimento de marca pessoal|Workshops de liderança avançada",
  link: "/HomePage",
  icon: TrendingUp
}, {
  id: "governance",
  tabLabel: "Governança",
  title: "Excelência em Gestão",
  description: "Capacitação técnica e comportamental para atuação em conselhos de administração e comitês estratégicos, elevando o padrão de governança corporativa.",
  bullets: "Formação para conselheiros|Melhores práticas de governança|Análise de cenários macroeconômicos|Certificações exclusivas MasterPro+",
  link: "/HomePage",
  icon: ChartBar
}];
export default function SolucoesCorporativas() {
  return;
}